defaultDataIdFromObject